<template>
  <div class="flex flex-col flex-grow h-full bg-zircon">
    <div class="flex flex-col md:flex-row flex-grow" style="min-height: 0;">
      <aside
        class="
          flex flex-col flex-shrink-0 bg-white md:bg-zircon
          px-6 py-6 md:px-10 md:py-10 md:w-96
          border-b md:border-b-0 md:border-r border-geyser
          md:overflow-y-auto
        ">
        <div
          class="
            flex flex-row items-center justify-between
            md:justify-start md:flex-col md:items-start md:space-y-8
          ">
          <a
            href="https://iwaly.ru/"
            class="flex flex-row items-center space-x-3">
            <img
              class="w-12 h-12 rounded-full"
              src="@/assets/iwaly.png"
              alt="iWALY">
            <div class="flex flex-col">
              <span class="text-18px leading-20px font-bold text-primary">
                iWALY
              </span>
              <span class="text-12px leading-16px text-muted">
                Сервис памяти и ухода
              </span>
            </div>
          </a>

          <a
            href="https://iwaly.ru/"
            class="
              hidden md:flex flex-row items-center space-x-2 cursor-pointer
            ">
            <img src="@/assets/icons/arrow.svg" alt="">
            <span class="text-sm leading-normal font-semibold text-primary">
              На главную
            </span>
          </a>
        </div>

        <div
          class="
            hidden md:flex flex-col space-y-6 mt-10
            text-14px leading-20px text-inverse
          ">
          <div class="flex flex-col space-y-3">
            <h2 class="text-20px leading-24px font-bold text-primary">
              iWALY — так просто быть ближе
            </h2>

            <p>
              Мы деликатный сервис, который объединяет семейный архив
              захоронений и дистанционный заказ услуг с проверенными
              исполнителями.
            </p>

            <p>
              Через iWALY клиенты могут заказать поиск захоронения, уборку,
              уход, доставку цветов, благоустройство, индивидуальные поручения
              и другие задачи, которые сложно организовать удалённо.
            </p>
          </div>

          <div class="rounded-lg overflow-hidden bg-white border border-geyser">
            <img
              class="w-full object-center object-cover"
              src="@/assets/images/poster-1.png"
              alt="iWALY">
          </div>

          <div
            class="
              flex flex-col space-y-3 rounded-lg
              bg-white border border-geyser p-5
            ">
            <strong class="text-primary">Для кого эта форма</strong>

            <p>
              Для исполнителей, волонтёров, подрядчиков, бригад, мастерских
              и специалистов, которые готовы выполнять деликатные задачи
              на кладбищах в своём регионе.
            </p>
          </div>
        </div>
      </aside>

      <main class="flex flex-col flex-grow" style="min-height: 0;">
        <div
          ref="contentScroll"
          class="flex-grow overflow-y-auto px-4 py-8 md:px-10 md:py-10">
          <article class="flex flex-col space-y-8 max-w-5xl mx-auto">
            <header class="flex flex-col space-y-4">
              <div class="flex flex-row items-center space-x-2 md:hidden">
                <a
                  href="https://iwaly.ru/"
                  class="text-primary text-sm font-semibold">
                  ← На главную
                </a>
              </div>

              <div class="flex flex-col space-y-3">
                <h1
                  class="
                    text-28px leading-32px md:text-32px md:leading-32px
                    font-bold text-primary
                  ">
                  Стать исполнителем iWALY
                </h1>

                <p class="text-16px leading-24px text-inverse max-w-3xl">
                  Заполните короткую форму. Это заявка на сотрудничество:
                  после отправки мы проверим данные, активируем аккаунт
                  исполнителя или свяжемся с вами для уточнения деталей.
                </p>
              </div>

              <div
                class="
                  flex flex-col md:flex-row md:items-center md:justify-between
                  rounded-lg bg-white border border-geyser p-5
                  space-y-4 md:space-y-0 md:space-x-6
                ">
                <div class="flex flex-col space-y-2">
                  <strong class="text-primary text-18px leading-22px">
                    Перед заполнением: как устроена работа исполнителя
                  </strong>

                  <span class="text-14px leading-20px text-muted max-w-2xl">
                    В FAQ собрали главное: регистрация, акцепт заказов,
                    безопасная сделка, выплаты, сервисные списания, стандарты
                    работ и волонтёрские обращения.
                    Сейчас подключение исполнителей идёт осторожно: если в регионе
                    заказов мало или исполнителей уже достаточно, мы принимаем заявку
                    только в резерв.
                  </span>
                </div>

                <button
                  class="
                    btn bg-primary border-solid border-primary
                    text-white flex-shrink-0
                  "
                  type="button"
                  @click="scrollToFaq">
                  Читать FAQ
                </button>
              </div>
            </header>

            <section class="bg-white rounded-lg border border-geyser p-5 md:p-8">
              <div class="flex flex-col space-y-6">
                <div class="flex flex-col space-y-2">
                  <h2 class="text-22px leading-26px font-bold">
                    Заявка на сотрудничество
                  </h2>

                  <p class="text-14px leading-20px text-muted">
                    Укажите актуальные данные, регион работы, ближайший
                    населённый пункт, услуги и комментарий. Чем подробнее
                    вы заполните форму, тем быстрее мы сможем подключить вас
                    к подходящим заказам.
                  </p>
                </div>

                <div
                  class="
                    rounded-lg border border-primary bg-hint p-5
                    text-14px leading-20px text-inverse
                  ">
                  <strong class="text-primary">Честно об ожиданиях:</strong>
                  <p class="mt-2">
                    iWALY — молодой сервис. В некоторых регионах исполнителей уже
                    больше, чем текущих заказов, поэтому заявка может быть принята
                    только в резерв. Это значит: мы будем рады сотрудничеству,
                    но не обещаем поток заказов и подключим вас к обращениям,
                    когда появится реальная потребность.
                  </p>
                  <p class="mt-2">
                    Быстрое автоматическое подключение сейчас оставляем только
                    для тех, кто выбирает исключительно «Помощь волонтёров».
                    Все остальные заявки тоже проходят подтверждение телефона,
                    создаются в системе и сохраняются для ручного рассмотрения.
                  </p>
                </div>

                <Stepper
                  :index="step"
                  :length="Object.keys(steps).length"/>

                <component
                  :is="component"
                  @prev="onPrev()"
                  @next="onNext()"
                  @send="onSend()"/>
              </div>
            </section>

            <ContractorAfterForm/>

            <ContractorFaq ref="faq"/>
          </article>
        </div>
      </main>
    </div>

    <MobileIdVerification
      :visible="mobileIdVisible"
      :phone="normalizedPhone"
      :token-url="mobileIdTokenUrl"
      @verified="onMobileIdVerified"
      @fallback="onMobileIdFallback"
      @close="onMobileIdClose"/>
  </div>
</template>

<script>
import _ from 'lodash';
import Stepper from '@/components/Stepper.vue';
import SignupStep1 from '@/components/signup/SignupStep1.vue';
import SignupStep3 from '@/components/signup/SignupStep3.vue';
import ContractorAfterForm from '@/components/signup/ContractorAfterForm.vue';
import ContractorFaq from '@/components/signup/ContractorFaq.vue';
import MobileIdVerification from '@/components/signup/MobileIdVerification.vue';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    Stepper,
    SignupStep1,
    SignupStep3,
    ContractorAfterForm,
    ContractorFaq,
    MobileIdVerification,
  },

  data() {
    return {
      step: 1,
      mobileIdVisible: false,
      mobileIdTokenUrl: '/contractor/mobile-id/token',
      steps: {
        SignupStep1,
        SignupStep3,
      },
    };
  },

  computed: {
    ...mapState({
      signupPayload: (state) => state.payload,
    }),

    component() {
      return Object.keys(this.steps)[this.step - 1];
    },

    canPrev() {
      return this.step > 1;
    },

    canNext() {
      return this.step < Object.keys(this.steps).length;
    },

    normalizedPhone() {
      return _.get(this.signupPayload, 'phone', '').replace(/\s/g, '');
    },

    isRussianMobileIdPhone() {
      return _.get(this.signupPayload, 'phoneCountryIso') === 'RU'
        && /^\+79\d{9}$/.test(this.normalizedPhone);
    },

    selectedServiceCategoryIds() {
      return _.get(this.signupPayload, 'serviceCategories') || [];
    },

    selectedServiceCategories() {
      const allCategories = _.get(this.$store, 'state.serviceCategories') || [];

      return this.selectedServiceCategoryIds.map((id) => allCategories.find(
        (item) => String(item.id) === String(id),
      ) || { id });
    },

    isVolunteerOnlyRegistration() {
      return this.selectedServiceCategories.length > 0
        && this.selectedServiceCategories.every(this.isVolunteerCategory);
    },
  },

  methods: {
    ...mapActions({
      REQUEST_CONFIRMATION_CODE: 'ACT_REQUEST_CONFIRMATION_CODE',
      VERIFY_MOBILE_ID: 'ACT_VERIFY_MOBILE_ID',
      REGISTRATION: 'ACT_REGISTRATION',
      SET_STEP: 'ACT_SET_STEP',
    }),

    onPrev() {
      if (this.canPrev) {
        this.step -= 1;
        this.scrollContentToTop();
      }
    },

    onNext() {
      if (this.canNext) {
        this.step += 1;
        this.scrollContentToTop();
      }
    },

    onSend() {
      if (this.isRussianMobileIdPhone) {
        this.mobileIdVisible = true;
        return;
      }

      this.requestStandardSmsCode();
    },

    async onMobileIdVerified(payload) {
      try {
        await this.VERIFY_MOBILE_ID(payload);
      } catch (error) {
        if (this.shouldFallbackAfterMobileIdVerifyError(error)) {
          this.onMobileIdFallback();
          return;
        }

        this.mobileIdVisible = false;
        this.notifyActionError(error);
        return;
      }

      try {
        await this.REGISTRATION();
        this.goToSuccess();
      } catch (error) {
        this.mobileIdVisible = false;
        this.notifyActionError(error);
      }
    },

    onMobileIdFallback() {
      this.requestStandardSmsCode()
        .then(() => {
          this.mobileIdVisible = false;
        })
        .catch(() => {
          this.mobileIdVisible = false;
        });
    },

    onMobileIdClose() {
      this.mobileIdVisible = false;
    },

    requestStandardSmsCode() {
      return this.REQUEST_CONFIRMATION_CODE()
        .catch((error) => {
          this.notifyActionError(error);
          return Promise.reject(error);
        });
    },

    goToSuccess() {
      this.mobileIdVisible = false;
      this.SET_STEP(3);
      this.scrollContentToTop();
    },

    shouldFallbackAfterMobileIdVerifyError(error) {
      const responseError = this.getResponseError(error);

      if ([
        'phone_already_registered',
        'phone_mismatch',
        'not_russian_mobile_phone',
        'invalid_phone',
      ].includes(responseError)) {
        return false;
      }

      return true;
    },

    notifyActionError(error) {
      this.$iwalyNotify.error({
        text: this.getErrorMessage(error),
      });
    },

    getResponseError(error) {
      return error && error.response && error.response.data
        ? error.response.data.error
        : null;
    },

    getErrorMessage(error) {
      const status = error && error.response
        ? error.response.status
        : null;

      const responseData = error && error.response
        ? error.response.data || {}
        : {};

      const responseError = responseData.error || null;
      const responseMessage = responseData.message || null;

      if (responseError === 'phone_already_registered') {
        return 'Этот номер уже зарегистрирован в системе. Если вы уже пользовались iWALY, войдите в аккаунт.';
      }

      if (responseError === 'too_many_phone_code_requests' || status === 429) {
        return responseMessage || 'Слишком много запросов кода. Повторите попытку позже.';
      }

      if (responseError === 'invalid_phone') {
        return 'Номер телефона указан неверно.';
      }

      if (responseError === 'unknown_phone') {
        return 'Номер телефона не найден. Запросите код подтверждения повторно.';
      }

      if (responseError === 'invalid_code') {
        return 'Код подтверждения введён неверно.';
      }

      if (responseError === 'not_allowed_region') {
        return 'Регистрация исполнителей в выбранном регионе пока недоступна.';
      }

      if (responseError === 'not_allowed_service_category') {
        return 'Одна из выбранных категорий услуг сейчас недоступна.';
      }

      if (responseError === 'contractor_auto_registration_only_volunteer') {
        return 'Автоматическая регистрация сейчас доступна только для категории «Помощь волонтёров». По остальным категориям мы принимаем заявку в резерв и рассматриваем её вручную.';
      }

      if (responseError === 'phone_mismatch') {
        return 'Номер, подтверждённый через Mobile ID, не совпадает с номером в форме.';
      }

      if (responseError === 'not_russian_mobile_phone') {
        return 'Mobile ID доступен только для российских мобильных номеров. Получите обычный SMS-код.';
      }

      if (status === 422) {
        return 'Проверьте заполненные данные и попробуйте ещё раз.';
      }

      if (status === 503 || status === 502) {
        return 'Сервис подтверждения временно недоступен. Попробуйте обычный SMS-код.';
      }

      return 'Не удалось продолжить регистрацию. Проверьте данные и попробуйте ещё раз.';
    },

    isVolunteerCategory(category) {
      const text = [
        _.get(category, 'id'),
        _.get(category, 'code'),
        _.get(category, 'slug'),
        _.get(category, 'alias'),
        _.get(category, 'name'),
      ].filter((value) => value !== null && typeof value !== 'undefined')
        .join(' ')
        .toLowerCase();

      return text.indexOf('volunteer_help') !== -1
        || text.indexOf('volunteer') !== -1
        || text.indexOf('волонт') !== -1
        || /(^|\s|,|;)10($|\s|,|;)/.test(text);
    },

    scrollContentToTop() {
      this.$nextTick(() => {
        const scroller = this.$refs.contentScroll;

        if (scroller && scroller.scrollTo) {
          scroller.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
          return;
        }

        if (scroller) {
          scroller.scrollTop = 0;
          return;
        }

        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    },
    scrollToFaq() {
      const { faq } = this.$refs;

      if (faq && faq.$el && faq.$el.scrollIntoView) {
        faq.$el.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    },
  },
};
</script>
